import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import i18n from "i18next";
import spanish from "../../../../assets/images/lang/spanish.png";
import english from "../../../../assets/images/lang/english.png";
import "./lang-button.css";
import { useTheme } from "../../../../common/hooks";

export default function LangButton() {
  const { theme } = useTheme();
  const [image, setImage] = useState(
    i18n.language.includes("es") ? spanish : english
  );
  const iconRef = useRef(null);

  const buttonStyle = {
    backgroundColor: theme.bgContrast,
  };

  const onClick = async () => {
    await gsap.to(iconRef.current, {
      y: 40,
      duration: 0.3,
    });
    i18n.changeLanguage(i18n.language.includes("es") ? "en" : "es");
    setImage(i18n.language.includes("es") ? spanish : english);
  };

  useEffect(() => {
    const animate = async () => {
      await gsap.fromTo(
        iconRef.current,
        {
          y: -40,
        },
        {
          y: 0,
          duration: 0.3,
        }
      );
    };
    animate();
  }, [image]);

  return (
    <button className="lang-button" style={buttonStyle} onClick={onClick}>
      <div className="icon-container" ref={iconRef}>
        <img src={image} alt="language" className="lang-icon" />
      </div>
    </button>
  );
}
